import hooks from './shipment-transfer-charges.hooks';

export default (app) => {
  const service = app.service('api/shipment-transfer-charges');

  // TODO: Remove this with feathers-dataloader update
  service.options = {
    id: 'id'
  };

  service.hooks(hooks);
};
